import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { AddPlusIcon } from '../../assets/icons';
import { InfiniteScroll, ModalButtonArea } from '../../common';
import { PageSearchBar } from '../../common/UniversalSearchForm/UniversalSearchForm';
import Button from '../../components/Button/Button';
import UserIcon from '../../components/icons/UserIcon';
import {
  PRODUCT_ROOM_TYPE_VALUE,
  LIFE_STYLE_UPLOAD_TAB,
  LIFE_STYLE_UPLOAD_TAB_LABEL,
  THUMBNAIL_MAX_WIDTH_RESOLUTION,
  THUMBNAIL_MAX_HEIGHT_RESOLUTION,
} from '../../constants/constants';
import { ROOM_TYPE } from '../../constants/roomConstants';
import {
  apiAddProductRendersIntoProduct,
  apiPostImageOnPresignedData,
  apiUploadAssetsToSalsify,
  apiUploadProductGifs,
  apiUploadProductImages,
  GetProductRenders,
} from '../../helpers/api';
import { createImageThumbnail, getFormData, getLocalStorage, wait } from '../../helpers/jsHelper';
import SkeletonLoaderUI, {
  SKELETON_LAYOUT,
  SKELETON_LOADER_TYPE,
} from '../../skeletonLoaderUI/SkeletonLoaderUI';
import { CardListUI } from './CardListUI';
import { UploadWithItemListModal } from './UploadWithItemListModal';
import { isEmpty } from 'lodash';
import { handleDownloadEditedImage } from '../../components/EditImageTool';
import { PASS, RENDER_IMAGE_TYPE } from '../../constants/renderPreviewConstants';
import { jpegFileFromBlobUrl } from '../../api/curator';
import { useStaticPermissions } from '../../hooks/usePermissions';
import { PERMISSION } from '../../constants/permissionConstants';

export const UploadRenderModal = (props) => {
  const {
    imageListForOpenModalType,
    setImageListForOpenModalType,
    type,
    productId,
    productInfo,
    handleRefresh,
    initialTab = null,
    setInitialTab = () => {},
  } = props;
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [hasNext, setHasNext] = useState(false);
  const [vignettePage, setVignettePage] = useState(1);
  const [vignetteList, setVignetteList] = useState([]);
  const [vignetteHasNext, setVignetteHasNext] = useState(false);
  const [lifestylePage, setLifestylePage] = useState(1);
  const [lifestyleList, setLifestyleList] = useState([]);
  const [lifestyleHasNext, setlifestyleHasNext] = useState(false);
  const [allSelectedFiles, setAllSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [meActive, setMeActive] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [initialPageLoad, setInitialPageLoad] = useState(false);
  const { hasPermission } = useStaticPermissions();
  const [tab, setTab] = useState(
    initialTab === PRODUCT_ROOM_TYPE_VALUE.UPLOAD_GIF
      ? LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF
      : initialTab === PRODUCT_ROOM_TYPE_VALUE.UPLOAD_IMAGES
      ? LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES
      : +type === PRODUCT_ROOM_TYPE_VALUE.SILO
      ? LIFE_STYLE_UPLOAD_TAB.SILOS
      : +type === PRODUCT_ROOM_TYPE_VALUE.VIGNETTE
      ? LIFE_STYLE_UPLOAD_TAB.VIGNETTE
      : LIFE_STYLE_UPLOAD_TAB.LIFESTYLE
  );

  useEffect(() => {
    if (initialTab !== null) {
      if (initialTab === PRODUCT_ROOM_TYPE_VALUE.UPLOAD_GIF) {
        setTab(LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF);
      } else if (initialTab === PRODUCT_ROOM_TYPE_VALUE.UPLOAD_IMAGES) {
        setTab(LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES);
      } else {
        setTab(LIFE_STYLE_UPLOAD_TAB.LIFESTYLE);
      }
    } else {
      if (+type === +PRODUCT_ROOM_TYPE_VALUE.SILO) {
        setTab(LIFE_STYLE_UPLOAD_TAB.SILOS);
      } else if (+type === +PRODUCT_ROOM_TYPE_VALUE.VIGNETTE) {
        setTab(LIFE_STYLE_UPLOAD_TAB.VIGNETTE);
      } else {
        setTab(LIFE_STYLE_UPLOAD_TAB.LIFESTYLE);
      }
    }
    setInitialPageLoad(!initialPageLoad);

    return () => setInitialTab?.(null);
  }, [type]);

  // temporary solution for pagination API call in big screen
  useEffect(() => {
    let dataCount = 0;
    switch (tab) {
      case LIFE_STYLE_UPLOAD_TAB.SILOS:
        dataCount = data?.length;
        break;
      case LIFE_STYLE_UPLOAD_TAB.LIFESTYLE:
        dataCount = lifestyleList?.length;
        break;
      case LIFE_STYLE_UPLOAD_TAB.VIGNETTE:
        dataCount = vignetteList?.length;
        break;
    }
    const { clientHeight } = document?.documentElement;
    if ((hasNext || vignetteHasNext || lifestyleHasNext) && clientHeight > 1075 && dataCount < 59) {
      fetchMoreData();
    }
  }, [vignetteList, data, lifestyleList, tab]);

  const handleSearchFeature = () => {
    switch (tab) {
      case LIFE_STYLE_UPLOAD_TAB.SILOS:
        +page === 1 ? setRefresh(!refresh) : setPage(1);
        break;
      case LIFE_STYLE_UPLOAD_TAB.LIFESTYLE:
        +lifestylePage === 1 ? setRefresh(!refresh) : setLifestylePage(1);
        break;
      case LIFE_STYLE_UPLOAD_TAB.VIGNETTE:
        +vignettePage === 1 ? setRefresh(!refresh) : setVignettePage(1);
        break;
    }
  };

  useEffect(() => {
    switch (tab) {
      case LIFE_STYLE_UPLOAD_TAB.SILOS:
        if (!data?.length) {
          fetchDataAPI(ROOM_TYPE?.SILO, page, setData, setHasNext);
        }
        break;
      case LIFE_STYLE_UPLOAD_TAB.LIFESTYLE:
        if (!lifestyleList?.length) {
          fetchDataAPI(ROOM_TYPE?.LIFESTYLE, lifestylePage, setLifestyleList, setlifestyleHasNext);
        }
        break;
      case LIFE_STYLE_UPLOAD_TAB.VIGNETTE:
        if (!vignetteList?.length) {
          fetchDataAPI(ROOM_TYPE?.VIGNETTE, vignettePage, setVignetteList, setVignetteHasNext);
        }
        break;
      default:
        break;
    }
    //Reset the selected item when the tab swith
    allSelectedFiles?.length > 0 && setAllSelectedFiles([]);
  }, [tab, type]);

  useEffect(() => {
    if (initialPageLoad) {
      switch (tab) {
        case LIFE_STYLE_UPLOAD_TAB.SILOS:
          fetchDataAPI(ROOM_TYPE?.SILO, page, setData, setHasNext);
          break;
        case LIFE_STYLE_UPLOAD_TAB.LIFESTYLE:
          fetchDataAPI(ROOM_TYPE?.LIFESTYLE, lifestylePage, setLifestyleList, setlifestyleHasNext);
          break;
        case LIFE_STYLE_UPLOAD_TAB.VIGNETTE:
          fetchDataAPI(ROOM_TYPE?.VIGNETTE, vignettePage, setVignetteList, setVignetteHasNext);
          break;

        default:
          break;
      }
    }
  }, [refresh, page, vignettePage, lifestylePage]);

  const fetchDataAPI = async (roomType, page, setDataFunction, hasNextFunction) => {
    let payload = {
      product: productInfo?.id,
      room_type: roomType,
      page: page,
      per_page: 20,
      sort: '-created_at',
    };
    if (searchText) {
      payload.search = searchText;
    }
    if (meActive) {
      payload.created_by = getLocalStorage('id');
    }
    setLoading(true);
    const result = await GetProductRenders(payload);
    hasNextFunction(result?.next_link ? true : false);
    if (page > 1) {
      setDataFunction((prevData) => [...prevData, ...result?.results]);
    } else {
      setDataFunction([...result?.results]);
    }
    setLoading(false);
  };

  const handleClose = () => {
    if (saveLoading || uploadLoading) return;
    setAllSelectedFiles([]);
  };

  const handleItemSelect = (item) => {
    if (allSelectedFiles.includes(item)) {
      // If the item is already in the list, remove it
      setAllSelectedFiles(allSelectedFiles.filter((i) => i?.id !== item?.id));
    } else {
      // If the item is not in the list, add it
      setAllSelectedFiles([...allSelectedFiles, item]);
    }
  };

  function getPass(editConfig, isFilmic) {
    if (hasPermission(PERMISSION.IMAGE_EDITOR)) {
      return Object.keys(editConfig || {})?.length ? PASS.POST_EDIT : PASS.ORIGINAL;
    }
    return isFilmic ? PASS.FILMIC : PASS.STANDARD;
  }

  function getCurrentImage(image, isFilmic = false, pass) {
    const currentImage = image;
    if (pass === PASS.COLOR) {
      return currentImage?.extra_color_pass_file || currentImage?.color_pass_file;
    }
    const isFilmicImgType = isFilmic;
    return isFilmicImgType
      ? currentImage?.extra_filmic_file || currentImage?.filmic_file
      : currentImage?.extra_file || currentImage?.file;
  }

  function getOtherImage(image, isFilmic = false) {
    const currentImage = image;
    const isFilmicImgType = isFilmic;
    return isFilmicImgType
      ? currentImage?.extra_file || currentImage?.file
      : currentImage?.extra_filmic_file || currentImage?.filmic_file;
  }

  function getColorPassImage(image) {
    const currentImage = image;
    return currentImage?.extra_color_pass_file || currentImage?.color_pass_file;
  }

  async function callAPIsSequentially(apiUrls) {
    setSaveLoading(true);

    try {
      // Calculate max sequence number from Silos and Lifestyle imagery
      const currentMaxSequenceNumber =
        imageListForOpenModalType?.length > 0
          ? Math.max(...imageListForOpenModalType.map((item) => Number(item.sequence_number) || 0))
          : 0;
      // Execute all API calls in parallel and collect results
      const uploadResults = await Promise.allSettled(
        apiUrls.map(async (apiUrl, index) => {
          const sequenceNumber = currentMaxSequenceNumber + (index + 1);
          if (isEmpty(apiUrl?.edit_config)) {
            const payload = {
              product: productInfo?.id,
              version: 1,
              image_id: apiUrl?.id,
              room_type:
                type === PRODUCT_ROOM_TYPE_VALUE.SILO
                  ? ROOM_TYPE?.SILO
                  : type === PRODUCT_ROOM_TYPE_VALUE.VIGNETTE
                  ? ROOM_TYPE.VIGNETTE
                  : ROOM_TYPE?.LIFESTYLE,
              name: apiUrl?.render_name,
              sequence_number: sequenceNumber,
              is_ignore_salsify: true,
            };
            const formData = getFormData([payload]);
            return await apiAddProductRendersIntoProduct(formData);
          }
          const isFilmic = apiUrl?.img_type === RENDER_IMAGE_TYPE.FILMIC;
          const pass = getPass(apiUrl?.edit_config, isFilmic);
          const editedFile = await handleDownloadEditedImage({
            returnFile: true,
            url: getCurrentImage(apiUrl, isFilmic, pass),
            imageToolData: apiUrl?.edit_config,
            otherImage: getOtherImage(apiUrl, isFilmic),
            colorPassImage: getColorPassImage(apiUrl),
            title: apiUrl?.render_name,
          });
          const file = await jpegFileFromBlobUrl(editedFile, `${apiUrl?.render_name}.jpg`);
          const response = await handleFileUpload(
            [{ file, name: `${apiUrl?.render_name}.jpg`, renderId: apiUrl?.id, sequenceNumber }],
            LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES,
            false
          );
          return response?.[0]?.value?.data;
        })
      );

      // Collect successful uploads and their IDs
      const successfulUploads = uploadResults
        .filter((result) => result.status === 'fulfilled' && result?.value?.status)
        .map((result) => result.value?.data?.id)
        .filter(Boolean);

      // Collect any failed uploads for error handling
      const failedUploads = uploadResults.filter((result) => result.status === 'rejected');

      if (failedUploads.length > 0) {
        console.warn(`${failedUploads.length} uploads failed`, failedUploads);
      }

      // Upload collected render IDs to Salsify if any successful uploads
      if (successfulUploads.length > 0) {
        const _formData = new FormData();
        successfulUploads.forEach((id) => {
          _formData.append('upload_id', id);
        });
        await apiUploadAssetsToSalsify(_formData);
      }

      // https://app.clickup.com/t/3326989/DEV-42695
      // Waiting for 1.5 second because thumbnail generation takes some time,
      // which occasionally causes issues.
      await wait(1500);
      setSaveLoading(false);
      handleRefresh?.(type);
      props?.setShowModal(false);
      setImageListForOpenModalType([]);
    } catch (error) {
      console.error('Error in callAPIsSequentially:', error);
      setSaveLoading(false);
    }
  }

  const handleAddRender = async () => {
    if (loading) {
      return;
    }
    if (productInfo?.id) {
      setSaveLoading(true);
      callAPIsSequentially(allSelectedFiles);
    }
  };

  const fetchMoreData = () => {
    switch (tab) {
      case LIFE_STYLE_UPLOAD_TAB.SILOS:
        if (hasNext) setPage(+page + 1);
        break;
      case LIFE_STYLE_UPLOAD_TAB.LIFESTYLE:
        if (lifestyleHasNext) setLifestylePage(+lifestylePage + 1);
        break;
      case LIFE_STYLE_UPLOAD_TAB.VIGNETTE:
        if (vignetteHasNext) setVignettePage(+vignettePage + 1);
        break;
    }
  };

  const handleLoadDataTab = (list, nextPage, scrollSectionId) => {
    return (
      <>
        {loading && list && !list?.length && (
          <>
            {[0, 1].map((key) => {
              return (
                <SkeletonLoaderUI
                  key={key}
                  type={SKELETON_LOADER_TYPE.THUMBNAIL_CARD}
                  layout={SKELETON_LAYOUT.HORIZONTAL}
                  containerStyle={{
                    gridTemplateColumns: 'repeat(auto-fill, minmax(175px, 1fr))',
                    marginBottom: 15,
                  }}
                />
              );
            })}
          </>
        )}
        {!loading || list?.length > 0 ? (
          <InfiniteScroll
            dataLength={list?.length}
            next={fetchMoreData}
            hasMore={nextPage}
            scrollableTarget={scrollSectionId}>
            <div className="upload-gallery-wrapper" id={scrollSectionId}>
              <div className={`upload-gallery-inner ${list.length > 0 ? 'grid-view' : ''}`}>
                <CardListUI
                  items={list}
                  selectedItems={allSelectedFiles.map((a) => a.id)}
                  onCardClick={handleItemSelect}
                />
              </div>
              {loading && list?.length > 0 && (
                <SkeletonLoaderUI
                  type={SKELETON_LOADER_TYPE.THUMBNAIL_CARD}
                  layout={SKELETON_LAYOUT.HORIZONTAL}
                  containerStyle={{
                    gridTemplateColumns: 'repeat(auto-fill, minmax(175px, 1fr))',
                  }}
                />
              )}
            </div>
          </InfiniteScroll>
        ) : null}

        {allSelectedFiles && allSelectedFiles?.length > 0 && (
          <div className="text-end mt-3">
            <Button
              color="light"
              size="lg"
              className="add-btn"
              loading={saveLoading}
              iconBefore={<AddPlusIcon />}
              onClick={handleAddRender}>
              Add
            </Button>
          </div>
        )}
      </>
    );
  };

  const handleTabChange = (key) => {
    setTab(+key);
  };
  const onSearchChange = (value) => {
    setSearchText(value);
    handleSearchFeature();
    setAllSelectedFiles([]);
  };

  const handleFileUpload = async (files = [], uploadType, allowClose = true) => {
    let api = null;
    if (+uploadType === +LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF) {
      api = apiUploadProductGifs;
    } else if (+uploadType === +LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES) {
      api = apiUploadProductImages;
    }

    const roomType =
      +type === +PRODUCT_ROOM_TYPE_VALUE.SILO
        ? ROOM_TYPE.SILO
        : +type === +PRODUCT_ROOM_TYPE_VALUE.VIGNETTE
        ? ROOM_TYPE.VIGNETTE
        : ROOM_TYPE.LIFESTYLE;

    // Calculate max sequence number from Silos and Lifestyle imagery
    const currentMaxSequenceNumber =
      imageListForOpenModalType?.length > 0
        ? Math.max(...imageListForOpenModalType.map((item) => Number(item.sequence_number) || 0))
        : 0;

    setUploadLoading(true);
    const uploadResults = await Promise.allSettled(
      files.map(async (a, index) => {
        const payload = new FormData();
        payload.append('room_type', roomType);
        payload.append('product', productId);
        payload.append('name', a?.name?.split('.')[0]);
        payload.append('image_file_url_key', a?.name);
        payload.append(
          'sequence_number',
          Number.isFinite(Number(a?.sequenceNumber))
            ? Number(a?.sequenceNumber)
            : currentMaxSequenceNumber + (index + 1)
        );
        if (a?.renderId) {
          payload.append('image_id', a?.renderId);
          payload.append('is_edited_image', true);
        }
        if (+uploadType === +LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES) {
          payload.append('is_dimension_shot', a?.is_dimension_shot || false);
        }

        const response = await api(payload);
        if (response?.status) {
          const responseData = response?.data;

          // Upload Thumbnail
          if (responseData?.thumbnail_presigned_data) {
            const thumbnail = await createImageThumbnail({
              file: a?.file,
              customWidth: THUMBNAIL_MAX_WIDTH_RESOLUTION,
              customHeight: THUMBNAIL_MAX_HEIGHT_RESOLUTION,
            });
            apiPostImageOnPresignedData(thumbnail, responseData?.thumbnail_presigned_data);
          }

          await apiPostImageOnPresignedData(a?.file, responseData?.presigned_data);
        }

        return response;
      })
    );

    if (!allowClose) return uploadResults;

    // Collect all successful upload_ids and send to Salsify in a single API call
    if (+uploadType === +LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES) {
      const uploadIds = uploadResults
        .filter((result) => result.status === 'fulfilled' && result?.value?.status)
        .map((result) => result.value.data.id)
        .filter(Boolean);

      if (uploadIds.length > 0) {
        const _formData = new FormData();
        uploadIds.forEach((id) => {
          _formData.append('upload_id', id);
        });
        await apiUploadAssetsToSalsify(_formData);
      }
    }

    await wait(1500);
    handleRefresh?.(type);
    setUploadLoading(false);
    // if (finalResponse?.filter((a) => a.status === 'fulfilled')?.length > 0) {
    //   handleRefresh(type);
    // }

    props?.setShowModal(false);
    setImageListForOpenModalType([]);
  };

  return (
    <ModalButtonArea
      {...props}
      size="xl"
      startOpen={true}
      centered={true}
      bigButton={false}
      bigIcon={true}
      variant="link"
      buttonTitle={props.buttonTitle}
      iconBefore={props.iconBefore}
      onClose={handleClose}
      checkForPermission="UPLOAD_TEXTURE"
      className="upload-texture-modal lifystyle-popup"
      disabled={props.disableButton}
      backdropClassName="overlay-dark"
      preventFromClosing={saveLoading || uploadLoading}
      headingLeft
      {...(allSelectedFiles?.length !== 0 ||
        saveLoading ||
        (uploadLoading && { backdrop: 'static' }))}
      title={
        <>
          <h4>
            Add{' '}
            {`${
              type === PRODUCT_ROOM_TYPE_VALUE.SILO
                ? 'Silos'
                : type === PRODUCT_ROOM_TYPE_VALUE.VIGNETTE
                ? 'Vignette Imagery'
                : 'Lifestyle Imagery'
            }`}
          </h4>
        </>
      }
      body={
        <>
          {![PRODUCT_ROOM_TYPE_VALUE.UPLOAD_GIF, PRODUCT_ROOM_TYPE_VALUE.UPLOAD_IMAGES].includes(
            tab
          ) ? (
            <div className="search-container">
              <div className="filter">
                <button
                  className={meActive ? 'btn-table active' : 'btn-table'}
                  onClick={() => {
                    setMeActive(!meActive);
                    handleSearchFeature();
                    setAllSelectedFiles([]);
                  }}>
                  <UserIcon />
                  <span>My Images</span>
                </button>
              </div>
              <PageSearchBar
                model={''}
                onSearchChange={onSearchChange}
                search={searchText}
                hideTags={true}
              />
            </div>
          ) : null}
          <div className="setting-tabs">
            <Tabs
              className="mySettings-top-tabs"
              mountOnEnter
              unmountOnExit
              activeKey={tab}
              onSelect={handleTabChange}>
              <Tab
                eventKey={LIFE_STYLE_UPLOAD_TAB.SILOS}
                title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.SILOS]}>
                {handleLoadDataTab(data, hasNext, 'upload-gallery-silos')}
              </Tab>
              <Tab
                eventKey={LIFE_STYLE_UPLOAD_TAB.LIFESTYLE}
                title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.LIFESTYLE]}>
                {handleLoadDataTab(lifestyleList, lifestyleHasNext, 'upload-gallery-lifestyle')}
              </Tab>
              <Tab
                eventKey={LIFE_STYLE_UPLOAD_TAB.VIGNETTE}
                title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.VIGNETTE]}>
                {handleLoadDataTab(vignetteList, vignetteHasNext, 'upload-gallery-vignette')}
              </Tab>
              <Tab
                eventKey={LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF}
                title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF]}>
                <UploadWithItemListModal
                  type={LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF}
                  title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.UPLOAD_GIF]}
                  accept="image/gif"
                  restrictMultiple={true}
                  onClick={handleFileUpload}
                  loading={uploadLoading}
                />
              </Tab>
              <Tab
                eventKey={LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES}
                title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES]}>
                <UploadWithItemListModal
                  type={LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES}
                  title={LIFE_STYLE_UPLOAD_TAB_LABEL[LIFE_STYLE_UPLOAD_TAB.UPLOAD_IMAGES]}
                  accept="image/png, image/jpeg"
                  onClick={handleFileUpload}
                  loading={uploadLoading}
                  showHeader={true}
                  columns={[{ label: 'Dimension shot', key: 'is_dimension_shot' }]}
                />
              </Tab>
            </Tabs>
          </div>
        </>
      }
    />
  );
};
